/**
 * Dashboard
 * @namespace gplans.dashboard.services
 */
(function () {
  'use strict';
  angular.
  module('gplans.dashboard.services').
  factory('ValidateBmi', ValidateBmi);ValidateBmi.$inject = ["$rootScope", "MeasurementSystem"];


  function ValidateBmi($rootScope, MeasurementSystem) {
    "ngInject";

    var ValidateBmi = {
      validate: validate };


    return ValidateBmi;

    function validate(height, weight, mes_system, gender) {
      var maxHeight = 100;
      var minHeight = 50;
      var maxWeight = 500;
      var minWeight = 50;
      var maxBmi = 28;
      var minBmi = 18;
      var weightUnit = 'lbs';

      if (mes_system != 'US') {
        maxHeight = 250;
        minHeight = 125;
        maxWeight = 225;
        minWeight = 30;
        weightUnit = 'kg';
      }

      if (height >= minHeight && height <= maxHeight && weight >= minWeight && weight <= maxWeight) {
        if (mes_system == 'US') {
          if (gender == 'male') {
            var idealWeight = 106 + 6 * (height - 60);
          } else
          if (gender == 'female') {
            var idealWeight = 105 + 5 * (height - 60);
          }
          var minIdealWeight = Math.round(idealWeight * 0.9);
          if (weight < minIdealWeight) {
            alert('Min recommended weight is ' + minIdealWeight + ' ' + weightUnit);
            return minIdealWeight;
          }
        } else
        {
          height = MeasurementSystem.convertCmToInch(height);
          if (gender == 'male') {
            var idealWeight = 50 + 2.3 * (height - 60);
          } else
          if (gender == 'female') {
            var idealWeight = 45.5 + 2.3 * (height - 60);
          }
          var minIdealWeight = Math.round(idealWeight * 0.9);
          if (weight < minIdealWeight) {
            alert('Min recommended weight is ' + minIdealWeight + ' ' + weightUnit);
            return minIdealWeight;
          }
        }
      }
      return null;
    }
  }
})();